import { catalogApi as apiClient, catalogConfig, readCatalogPages, useCatalogResource } from "../components/catalog/catalogResources";

export async function loadAppointmentFormOptions(companyId, warehouseId, signal, search, serviceId) {
  const [servicePage, currentService, clients, staff, warehouses] = await Promise.all([
    apiClient.get("/api/services", catalogConfig(companyId, signal, { page: 1, limit: 50, status: "active", search })),
    serviceId ? apiClient.get(`/api/services/${serviceId}`, catalogConfig(companyId, signal)) : null,
    apiClient.get("/api/users/customers", catalogConfig(companyId, signal, { companyId, ...(warehouseId ? { warehouseId } : {}) })),
    readCatalogPages("/api/users", "users", companyId, signal, { companyId, user_type: "staff_members" }),
    readCatalogPages("/api/warehouses", "warehouses", companyId, signal),
  ]);
  if (!Array.isArray(servicePage.data?.services) || !Array.isArray(clients.data)) throw new Error("Les choix du rendez-vous sont indisponibles.");
  const services = [...servicePage.data.services, ...(currentService ? [currentService.data] : [])];
  if (services.some((row) => row.company_id != null && String(row.company_id) !== String(companyId))) throw new Error("Le contexte du service a changé.");
  return {
    services: Array.from(new Map(services.map(({ id, name, duration_minutes, base_price, warehouse_id, is_active }) =>
      [Number(id), { id: Number(id), name, duration_minutes, base_price, warehouse_id, is_active }])).values()),
    customers: Array.from(new Map(clients.data.map(({ id, name, phone }) => [Number(id), { id: Number(id), name, phone }])).values()),
    staff: staff.map(({ id, name }) => ({ id: Number(id), name })), warehouses: warehouses.map(({ id, name }) => ({ id, name })),
  };
}

export default function useAppointmentFormOptions(scope, open, search, serviceId) {
  return useCatalogResource("appointment-form-options", scope,
    (signal) => loadAppointmentFormOptions(scope.companyId, scope.warehouseId, signal, search, serviceId),
    [search, serviceId || null], open, open);
}
